import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import RootLayout from './pages/Root';
import ErrorPage from './pages/Error';
import HomePage from './pages/Home';

import './App.css';
import PortfolioPage from './pages/Portfolio';
import { action as authorizeAction } from './components/AuthForm';
import AuthPage from './pages/Auth';
import { action as logoutAction } from './pages/Logout';
import { tokenLoader, checkAuthLoader } from './util/auth';

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    id: 'root',
    loader: tokenLoader,
    children: [
      { index: true, element: <HomePage /> },
      {
        path: 'admin',
        element: <AuthPage />,
        action: authorizeAction,
      },
      {
        path: 'logout',
        action: logoutAction
      },
      {
        path: 'portfolio',
        children: [
          {
            index: true,
            element: <PortfolioPage />
          }
        ]
      }
    ]
  }
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
